export interface BuildPlanApprovalMessageOptions {
  /** Optional accepted plan path (kept for call-site compatibility; message remains path-agnostic). */
  planPath?: string
  draftInput?: string
}

const PLAN_APPROVAL_LINE = 'Plan approved. Read and execute the accepted plan. Use subagents where possible for parallel phases. Call TaskUpdate to mark checklist items as they are completed. After all tasks are done, present a summary of what was completed, what failed (with reasons), and any next steps.'

function normalizeDraftInput(input?: string): string {
  return (input ?? '').trim()
}

export function buildPlanApprovalMessage(options: BuildPlanApprovalMessageOptions = {}): string {
  const draftInput = normalizeDraftInput(options.draftInput)

  const sections: string[] = [PLAN_APPROVAL_LINE]

  if (options.planPath?.trim()) {
    sections.push(`**Accepted plan file:** \`${options.planPath}\``)
  }

  if (draftInput.length > 0) {
    sections.push(['---', '**Additional user context**', draftInput].join('\n\n'))
  }

  return sections.join('\n\n')
}
